module.exports = __webpack_public_path__ + "static/media/recentFeedMotor.311d053e.svg";